import { isSaleOut } from '@/api/sale';
import Queue from '@/utils/queue';
import manager from '../manager';
import $ from 'jquery'


const saleOutQueue=new Queue(isSaleOut)

manager.add('SaleOutMark', {
	async created(id) {
		if(!id)return
		var isSaleOut = (await saleOutQueue.get(id))||false
        if(isSaleOut){
            $(this.dom).css("display","block")
        }
	}
})
